import React from 'react';
import classes from "./style.module.scss"
import useStyles from 'isomorphic-style-loader/useStyles'

const MeListEmpty = props => {
    useStyles(classes)

    return <div className={classes.ListEmpty}>
        no more data
    </div>
}

export default MeListEmpty